import { Provider } from "components/job/JobContext";
import { JobList } from "components/job/JobList";
import React from "react";
export const Jobs = () => {
    return (
        <Provider>
            <JobList />
        </Provider>
    );
};
